import { render, staticRenderFns } from "./GradingNotice.vue?vue&type=template&id=de271c70&scoped=true"
import script from "./GradingNotice.vue?vue&type=script&lang=js"
export * from "./GradingNotice.vue?vue&type=script&lang=js"
import style0 from "./GradingNotice.vue?vue&type=style&index=0&id=de271c70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de271c70",
  null
  
)

export default component.exports